export default __webpack_public_path__ + "static/media/PersonNotFound.d2317417eb621f0d.svg";